(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('assignAirCrewCtrl', assignAirCrewCtrl)
        .controller('assignAirCrewEditCtrl', assignAirCrewEditCtrl)
        .controller('modalAddNewChargeCtrl', modalAddNewChargeCtrl)
        .controller('modalEditChargeCtrl', modalEditChargeCtrl)
        .controller('modalAddNewCommandCrewCtrl', modalAddNewCommandCrewCtrl)
        .controller('modalAddNewComplementaryCrewCtrl', modalAddNewComplementaryCrewCtrl)


    assignAirCrewCtrl.$inject = ['linkService', 'assignAirCrews','plaqueAirCrafts','$stateParams'];

    assignAirCrewEditCtrl.$inject = ['linkService', '$uibModal',
        'assignAirCrewsLoadForm', 'assignAirCrewService', '$stateParams'];

    //-----------------MODALS
    modalAddNewChargeCtrl.$inject = ['linkService','$uibModal','$uibModalInstance','assignAirCrewService',
        'occupationCrewCharges','occupationCommandCrewCharges','indexX','assignForms','$timeout','messageService'];

    modalEditChargeCtrl.$inject = ['linkService', '$uibModal', '$uibModalInstance','assignAirCrewService',
        'occupationCommandCrewCharges', 'occupationCrewCharges','indexX', 'assignForms', 'index', 'loadForm','messageService'];

    modalAddNewCommandCrewCtrl.$inject = ['linkService','$uibModal','$uibModalInstance','occupationCrewService',
        'isModal', 'typeCrew','occupationCrewCharges','modelAirCrafts',  'datePickerService', 'airCrewService'];

    modalAddNewComplementaryCrewCtrl.$inject = ['linkService','$uibModal','$uibModalInstance','occupationCrewService',
        'isModal','occupationCrewCharges','modelAirCrafts', 'datePickerService', 'complementAirCrewService'];

    function assignAirCrewCtrl(linkService, assignAirCrews,plaqueAirCrafts,$stateParams) {
        var vm = this;
        vm.searchFrom = {
            'actualDate': ($stateParams.departureDate != "") ? new Date(parseInt($stateParams.departureDate)) : new Date(),
            'plaqueAirCraft': ($stateParams.plaque != "all") ? $stateParams.plaque : null
        }
        vm.assignAirCrews = assignAirCrews;
        vm.plaqueAirCrafts = (plaqueAirCrafts.data._embedded) ? plaqueAirCrafts.data._embedded.aircrafts : [];
        vm.linkService = linkService;

        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: false
            },
            closed: function (args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };

        // CALENDAR ================================================================

        vm.cancel = function () {
            linkService.reloadRoute('assignAirCrews', null);
        }

        vm.searchAssignAirCrew = function (isValid, searchForm) {
            var ts = Date.parse(searchForm.actualDate);
            var plaque = "all";

            if (searchForm.plaqueAirCraft != null) {
                plaque = parseInt(searchForm.plaqueAirCraft)
            }
            linkService.reloadRoute(linkService.getCurrentRouteName(), {departureDate: ts,plaque: plaque})
        };

        vm.getDepartureFlightIds = function (departureFlights) {
            var ids = "";
            angular.forEach(departureFlights, function (departureFlight, index) {
                if (index == 0) {
                    ids = ids + linkService.getLinkId(departureFlight._links.self.href)
                } else {
                    ids = ids + "_" + linkService.getLinkId(departureFlight._links.self.href)
                }
            });
            return ids;
        }
    }

    function assignAirCrewEditCtrl(linkService, $uibModal,assignAirCrewsLoadForm,
                                   assignAirCrewService,$stateParams) {
        var vm = this;
        vm.$uibModal = $uibModal;
        vm.assignForms = [];
        vm.cabinChiefs = [];
        vm.assistants = [];
        //vm.assignAirCrews = assignAirCrews;
        vm.linkService = linkService;
        vm.existsAssitant = false;
        vm.selectedItemsDialog = []

        vm.cancel = function () {
            linkService.reloadRoute('assignAirCrew', null);
        }

        vm.assignAirCrewsLoadForm = assignAirCrewsLoadForm;

        vm.departureFlightForm = {
            "departureFlights": [],
            "flightNumber": vm.assignAirCrewsLoadForm.flight.flightNumber
        };

        vm.assignAirCrewFormAux = {
            "typeCrew": null,
            "occupationCrew": null,
            "member": null
        }

        //----------------------------------------------------------------------------------------------------

        var dataArrayAssistantsHeadCabins = {
            "dataArray": []
        }

        var isAbleToAdd = {
            "dataArray": []
        }

        angular.forEach(vm.assignAirCrewsLoadForm.flight._embedded.departureflights, function (assignAirCrew, $indexDepartureflights) {

            dataArrayAssistantsHeadCabins.dataArray.push({
                "indexDepartureflights": $indexDepartureflights,
                "airCrewData": [{
                    "headCabins": [],
                    "assistants": []
                }]
            });

            isAbleToAdd.dataArray.push({
                "indexDepartureflights": $indexDepartureflights,
                "headCabins": [],
                "assistants": []
            });

            angular.forEach(assignAirCrew._embedded.aircrewFlights, function (aircrewFlights) {
                if (aircrewFlights._embedded.occupationCrew.lang == "air.aircrew.typeCrew.assistant") {
                    dataArrayAssistantsHeadCabins.dataArray[$indexDepartureflights].airCrewData[0].assistants.push(
                        aircrewFlights
                    );
                } else if (aircrewFlights._embedded.occupationCrew.lang == "air.aircrew.typeCrew.cabinChief") {
                    dataArrayAssistantsHeadCabins.dataArray[$indexDepartureflights].airCrewData[0].headCabins.push(
                        aircrewFlights
                    );
                }
            });

            if (dataArrayAssistantsHeadCabins.dataArray[$indexDepartureflights].airCrewData[0].assistants.length > 0) {
                isAbleToAdd.dataArray[$indexDepartureflights].assistants.push({
                    "assistantsAbleToAdd": true
                })
            } else {
                isAbleToAdd.dataArray[$indexDepartureflights].assistants.push({
                    "assistantsAbleToAdd": false
                })
            }

            if (dataArrayAssistantsHeadCabins.dataArray[$indexDepartureflights].airCrewData[0].headCabins.length > 0) {
                isAbleToAdd.dataArray[$indexDepartureflights].headCabins.push({
                    "headCabinAbleToAdd": true
                })
            } else {
                isAbleToAdd.dataArray[$indexDepartureflights].headCabins.push({
                    "headCabinAbleToAdd": false
                })
            }

        });

        // ..................................................................................

        vm.validateHeadCabinAssistantUnique = function (indexX, index, formAssignAirCrew, type) {
            var headCabinAssistants = (type === 1) ? vm.departureFlightForm.departureFlights[indexX].headCabins : vm.departureFlightForm.departureFlights[indexX].assistants;
            var selectHeadCabinAssistant = (type === 1) ? vm.departureFlightForm.departureFlights[indexX].headCabins[index].headCabin : vm.departureFlightForm.departureFlights[indexX].assistants[index].assistant;
            var formName = (type === 1) ? "headCabins" : "assistants";
            var errorMessage = (type === 1) ? "uniqueHeadCabinName" : "uniqueAssistantName";

            if(headCabinAssistants.length > 1){
                if(selectHeadCabinAssistant !== undefined && selectHeadCabinAssistant !== null) {
                    var isHeadCabinAssistant = assignAirCrewService.thereHeadCabinAssistant(headCabinAssistants, selectHeadCabinAssistant, type);
                    if(isHeadCabinAssistant){
                        formAssignAirCrew[formName].$setValidity(errorMessage, false);
                    }else{
                        formAssignAirCrew[formName].$setValidity(errorMessage, true);
                    }
                }else{
                    formAssignAirCrew[formName].$setValidity(errorMessage, true);
                }
            }
        }

        vm.validateHeadCabinInserted = function (headCabin, $index, indexX, formAssignAirCrew) {

            dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].headCabins.push({
                "_embedded": {
                    "aircrew": headCabin,
                    "occupationCrew": {}
                },
                "active": true,
                "_links": {}
            });

            var findOne = false;
            for (var i = 0; i < dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].headCabins.length - 1; i++) {
                if (linkService.getLinkId(headCabin._links.self.href) == linkService.getLinkId(dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].headCabins[i]._embedded.aircrew._links.self.href)) {
                    findOne = true;
                }
            }

            if (findOne) {
                formAssignAirCrew.headCabins.$setValidity("uniqueAssistantName", false);
                isAbleToAdd.dataArray[indexX].headCabins[0].headCabinAbleToAdd = false;
            } else {
                formAssignAirCrew.headCabins.$setValidity("uniqueAssistantName", true);
                isAbleToAdd.dataArray[indexX].headCabins[0].headCabinAbleToAdd = true;
            }
        };

        vm.validateAssistantInserted = function (assistant, $index, indexX, formAssignAirCrew) {

            dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].assistants.push({
                "_embedded": {
                    "aircrew": assistant,
                    "occupationCrew": {}
                },
                "active": true,
                "_links": {}
            });

            var findOne = false;
            for (var i = 0; i < dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].assistants.length - 1; i++) {
                if (linkService.getLinkId(assistant._links.self.href) == linkService.getLinkId(dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].assistants[i]._embedded.aircrew._links.self.href)) {
                    findOne = true;
                }
            }

            if (findOne) {
                formAssignAirCrew["assistants_" + $index].$setValidity("uniqueAssistantName", false);
                isAbleToAdd.dataArray[indexX].assistants[0].assistantsAbleToAdd = false;
            } else {
                formAssignAirCrew["assistants_" + $index].$setValidity("uniqueAssistantName", true);
                isAbleToAdd.dataArray[indexX].assistants[0].assistantsAbleToAdd = true;
            }

        };

        //----------------------------------------------------------------------------------------------------
        getAssignToArray(assignAirCrewsLoadForm);

        angular.forEach(vm.assignAirCrewsLoadForm.flight._embedded.departureflights, function (assignAirCrew, index) {
            vm.departureFlightForm.departureFlights.push({
                "modelAircraft": assignAirCrew._embedded.modelAircraft,
                "segment": assignAirCrew._embedded.segment,
                "pilot": (assignAirCrew._embedded.aircrewFlights) ? getAircrewFlightType('PLT', assignAirCrew._embedded.aircrewFlights) : null,
                "coPilot": (assignAirCrew._embedded.aircrewFlights) ? getAircrewFlightType('CPL', assignAirCrew._embedded.aircrewFlights) : null,
                "headCabins": getAllDataArray(assignAirCrew._embedded.aircrewFlights, 'JDC').length > 0 ?
                    getAllDataArray(assignAirCrew._embedded.aircrewFlights, 'JDC') : [{
                    "headCabin": null
                }]
                ,
                "assistants": getAllDataArray(assignAirCrew._embedded.aircrewFlights, 'AST').length > 0 ?
                    getAllDataArray(assignAirCrew._embedded.aircrewFlights, 'AST') : [{
                    "assistant": null
                }]
                ,
                "anotherCharges": [{
                    "anotherCharge": null
                }],
                "departureFlightId": parseInt(linkService.getLinkId(assignAirCrew._links.self.href))
            });
            vm.assignForms[index].assignAirCrew = getAnotherCrews(assignAirCrew._embedded.aircrewFlights);
        });
        vm.old = angular.copy(vm.departureFlightForm.departureFlights);
        vm.oldAC = angular.copy(vm.assignForms);
        vm.buttonSave = true;
        if (vm.old[0].pilot == null) {
            vm.buttonSave = false;
        }

        function getAnotherCrews(anotherCrews) {
            var res = [];
            angular.forEach(anotherCrews, function(anotherCharge) {
                //if(!anotherCharge._embedded.occupationCrew.essential){
                if((anotherCharge._embedded.occupationCrew.initials !== 'PLT') &&
                    (anotherCharge._embedded.occupationCrew.initials !== 'CPL') &&
                    (anotherCharge._embedded.occupationCrew.initials !== 'JDC') &&
                    (anotherCharge._embedded.occupationCrew.initials !== 'AST')){
                    res.push({
                        "orden": 0,
                        "chargeName": anotherCharge._embedded.occupationCrew.name,
                        "commandCrew": anotherCharge._embedded.occupationCrew.commandCrew,
                        "member": anotherCharge._embedded.aircrew,
                        "charge": anotherCharge._embedded.occupationCrew,
                        "aircrewId": parseInt(linkService.getLinkId(anotherCharge._embedded.aircrew._links.self.href)),
                        "occupationCrewId": parseInt(linkService.getLinkId(anotherCharge._embedded.occupationCrew._links.self.href))
                    });
                }
            });

            return res;
        }

        function getAircrewFlightType(type, aircrewFlights) {
            var res = null;
            for (var i = 0; i < aircrewFlights.length; i++) {
                if (aircrewFlights[i]._embedded.occupationCrew.initials == type) {
                    res = aircrewFlights[i]._embedded.aircrew;
                    break;
                }
            }
            return res;
        }

        function getAllDataArray(dataArray, type) {
            var array = [];

            if (type === "AST") {
                angular.forEach(dataArray, function (dataArrayJSON) {
                    if (dataArrayJSON._embedded.occupationCrew.initials === type) {
                        array.push({
                            "assistant": {
                                "_embedded": {
                                    "occupationCrew": dataArrayJSON._embedded.occupationCrew
                                },
                                "name": dataArrayJSON._embedded.aircrew.name,
                                "lastName": dataArrayJSON._embedded.aircrew.lastName,
                                "nroIdentity": dataArrayJSON._embedded.aircrew.nroIdentity,
                                "address": dataArrayJSON._embedded.aircrew.address,
                                "phone": dataArrayJSON._embedded.aircrew.phone,
                                "license": dataArrayJSON._embedded.aircrew.license,
                                "expirationDate": dataArrayJSON._embedded.aircrew.expirationDate,
                                "active": dataArrayJSON._embedded.aircrew.active,
                                "typeCrew": dataArrayJSON._embedded.aircrew.typeCrew,
                                "_links": dataArrayJSON._embedded.aircrew._links
                            }
                        });
                    }
                })
            } else if (type === "JDC") {
                angular.forEach(dataArray, function (dataArrayJSON) {
                    if (dataArrayJSON._embedded.occupationCrew.initials === type) {
                        array.push({
                            "headCabin": {
                                "_embedded": {
                                    "occupationCrew": dataArrayJSON._embedded.occupationCrew
                                },
                                "name": dataArrayJSON._embedded.aircrew.name,
                                "lastName": dataArrayJSON._embedded.aircrew.lastName,
                                "nroIdentity": dataArrayJSON._embedded.aircrew.nroIdentity,
                                "address": dataArrayJSON._embedded.aircrew.address,
                                "phone": dataArrayJSON._embedded.aircrew.phone,
                                "license": dataArrayJSON._embedded.aircrew.license,
                                "expirationDate": dataArrayJSON._embedded.aircrew.expirationDate,
                                "active": dataArrayJSON._embedded.aircrew.active,
                                "typeCrew": dataArrayJSON._embedded.aircrew.typeCrew,
                                "_links": dataArrayJSON._embedded.aircrew._links
                            }
                        });
                    }
                })
            }
            return array;
        }

        vm.airCrew = {
            "pilots": vm.assignAirCrewsLoadForm.pilots,
            "coPilots": vm.assignAirCrewsLoadForm.coPilots,
            "headCabin": vm.assignAirCrewsLoadForm.headCabin,
            "assistant": vm.assignAirCrewsLoadForm.assistant,
            "flight": vm.assignAirCrewsLoadForm.flight
        }

        vm.addAnotherCharge = function (indexX) {
            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/flightControl/airCrew/assignAirCrew/addAnotherChargeForm.html',
                controller: 'modalAddNewChargeCtrl',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    'occupationCommandCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                        return assignAirCrewService.getCommandCrewCharge()
                    }],
                    'occupationCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                        return assignAirCrewService.getOccupationCrewCharge()
                    }],
                    'indexX': [function () {
                        return indexX
                    }],
                    'assignForms': [function () {
                        return vm.assignForms;
                    }]
                }
            });
            modalInstance.result.then(function (res) {
                vm.change();
            }, function () {
            });
        }

        vm.addToArray = function (arr, index, indexX) {
            var isElementNullHeadCabins = null;
            var isElementNullAssistants = null;

            if (arr == 1) {
                angular.forEach(vm.departureFlightForm.departureFlights[indexX].headCabins, function (headCabins) {
                    if (headCabins.headCabin) {
                        isElementNullHeadCabins = true;
                    } else if (!headCabins.headCabin) {
                        isElementNullHeadCabins = false;
                    }
                });
            } else if (arr == 2) {
                angular.forEach(vm.departureFlightForm.departureFlights[indexX].assistants, function (assistants) {
                    if (assistants.assistant) {
                        isElementNullAssistants = true;
                    } else if (!assistants.assistants) {
                        isElementNullAssistants = false;
                    }
                });
            }

            if (arr == 1 && isElementNullHeadCabins/* && isAbleToAdd.dataArray[indexX].headCabins[0].headCabinAbleToAdd*/) {
                vm.departureFlightForm.departureFlights[indexX].headCabins.push({
                    "headCabin": null
                });
            } else if (arr == 2 && isElementNullAssistants/* && isAbleToAdd.dataArray[indexX].assistants[0].assistantsAbleToAdd*/) {
                vm.departureFlightForm.departureFlights[indexX].assistants.push({
                    "assistant": null
                });
            }

            vm.change();
        }

        vm.deleteFromArray = function (arr, indexX, $index, orden) {
            if (arr == 1) {
                vm.departureFlightForm.departureFlights[indexX].headCabins.splice($index, 1);
                isAbleToAdd.dataArray[indexX].assistants[0].assistantsAbleToAdd = true;
                dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].headCabins.splice($index, 1)
            } else if (arr == 2) {
                vm.departureFlightForm.departureFlights[indexX].assistants.splice($index, 1);
                isAbleToAdd.dataArray[indexX].assistants[0].assistantsAbleToAdd = true;
                dataArrayAssistantsHeadCabins.dataArray[indexX].airCrewData[0].assistants.splice($index, 1)
            }
            vm.change();
        }

        vm.deleteAnotherCharge = function (orden, $index, indexY) {
            vm.assignForms[indexY].assignAirCrew.splice($index, 1)
            vm.change();
        }

        vm.editAnotherCharge = function (data, index, indexX, indexY) {
            vm.assignAirCrewForm = {
                "typeCrew": vm.assignForms[indexX].assignAirCrew[indexY].commandCrew ? 0 : 1,
                "occupationCrew": vm.assignForms[indexX].assignAirCrew[indexY].charge,
                "member": vm.assignForms[indexX].assignAirCrew[indexY].member
            }

            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/flightControl/airCrew/assignAirCrew/addAnotherChargeForm.html',
                controller: 'modalEditChargeCtrl',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    'occupationCommandCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                        return assignAirCrewService.getCommandCrewCharge()
                    }],
                    'occupationCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                        return assignAirCrewService.getOccupationCrewCharge()
                    }],
                    'indexX': [function () {
                        return indexX
                    }],
                    'assignForms': [function () {
                        return vm.assignForms;
                    }],
                    'index': index,
                    'loadForm': [function () {
                        return vm.assignAirCrewForm;
                    }]
                }
            });
            modalInstance.result.then(function (res) {
            }, function () {
            });
            vm.change();
        }

        function getAssignToArray(assignAirCrewsLoadForm) {
            angular.forEach(assignAirCrewsLoadForm.flight._embedded.departureflights, function (departureFlight) {
                vm.assignForms.push({
                    'assistants': [],
                    'cabinChiefs': [],
                    'assignAirCrew': []
                })
            });
        }

        vm.listUpdateAssignAirCrew = function (airCrewKey, airCrew) {
            vm.airCrew[airCrewKey].push(airCrew);
        }

        vm.addNewCommandCrew = function () {
            vm.$uibModal.open({
                templateUrl: 'app/admin/flightControl/airCrew/airCrew/modalAddNewAirCrew.html',
                controller: 'modalAddNewAirCrewCtrl',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    'modelAirCrafts': ['modelAircraftService', function (modelAircraftService) {
                        return modelAircraftService.getModelAircrafts()
                    }],
                    'modelAirCraft': [function(){
                        return vm.departureFlightForm.departureFlights[0].modelAircraft;
                    }]
                }
            }).result.then(function (response) {
                var airCrewKey = (response.typeCrew === 0) ? 'pilots' : 'coPilots';
                vm.listUpdateAssignAirCrew(airCrewKey, response.airCrew);
            }, function () {});
        }

        vm.addNewCabinCrew = function () {
            vm.$uibModal.open({
                templateUrl: 'app/admin/flightControl/airCrew/complementAirCrew/modalComplementAirCrew.html',
                controller: 'modalComplementAirCrewNewCtrl',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    'occupationComplementAirCrewList': ['complementAirCrewService', function (complementAirCrewService) {
                        return complementAirCrewService.getOccupationCrewListComplement()
                    }]
                }
            }).result.then(function (response) {
                var typeOccupation = response.airCrew._embedded.occupationCrew.initials;

                if (typeOccupation === 'JDC') {
                    vm.listUpdateAssignAirCrew('headCabin', response.airCrew);
                } else if (typeOccupation === 'AST'){
                    vm.listUpdateAssignAirCrew('assistant', response.airCrew);
                }
            }, function () {});
        }

        vm.updateAssignAirCrew = function (isValid) {
            var updateDepartureFlights = {
                "departureFlights": []
            }

            angular.forEach(vm.departureFlightForm.departureFlights, function (departureFlight, index) {
                updateDepartureFlights.departureFlights.push({
                    "departureFlightId": departureFlight.departureFlightId,
                    "aircrewFlights": []
                });

                updateDepartureFlights.departureFlights[index].aircrewFlights.push({
                    "aircrewId": parseInt(linkService.getLinkId(departureFlight.pilot._links.self.href)),
                    "occupationCrewId": 1
                });

                updateDepartureFlights.departureFlights[index].aircrewFlights.push({
                    "aircrewId": parseInt(linkService.getLinkId(departureFlight.coPilot._links.self.href)),
                    "occupationCrewId": 2
                });

                angular.forEach(departureFlight.headCabins, function (headCabin) {
                    updateDepartureFlights.departureFlights[index].aircrewFlights.push({
                        "aircrewId": parseInt(linkService.getLinkId(headCabin.headCabin._links.self.href)),
                        "occupationCrewId": 6
                    });
                });

                if (departureFlight.assistants[0].assistant != null) {
                    angular.forEach(departureFlight.assistants, function (assistant) {
                        updateDepartureFlights.departureFlights[index].aircrewFlights.push({
                            "aircrewId": parseInt(linkService.getLinkId(assistant.assistant._links.self.href)),
                            "occupationCrewId": 7
                        });
                    });
                }

                angular.forEach(vm.assignForms[index].assignAirCrew, function (assignAirCrew) {
                    updateDepartureFlights.departureFlights[index].aircrewFlights.push({
                        "aircrewId": assignAirCrew.aircrewId,
                        "occupationCrewId": assignAirCrew.occupationCrewId
                    });
                })
            });

            if (isValid) {
                assignAirCrewService.updateAssignAirCrew($stateParams.id, updateDepartureFlights)
                    .then(function (res) {
                        linkService.reloadRoute('assignAirCrew', null)
                    });
            }
        }

        vm.change = function () {
            if (vm.old[0].pilot != null) {
                vm.buttonSave = true;
                var flagSame = true;
                for (var i = 0; i < vm.departureFlightForm.departureFlights.length; i++) {
                    var newDF = vm.departureFlightForm.departureFlights[i];
                    if (same(newDF.pilot, vm.old[i].pilot) && same(newDF.coPilot, vm.old[i].coPilot) &&
                        !withChanges(newDF.headCabins, vm.old[i].headCabins, false) &&
                        !withChanges(newDF.assistants, vm.old[i].assistants, false) &&
                        !withChanges(vm.assignForms[i].assignAirCrew, vm.oldAC[i].assignAirCrew,true)) {
                        flagSame = true;
                    } else {
                        flagSame = false;
                        break;
                    }
                }

                if(!flagSame){
                    vm.buttonSave = false;
                }
            }
        }

        function getId(object) {
            return vm.linkService.getLinkId(object._links.self.href);
        }

        function withChanges(newList, oldList, anotherCharge) {
            var res = false;
            if(newList.length == oldList.length){
                for(var i=0; i<newList.length; i++){
                    var flag = false;
                    for(var j=0; j<oldList.length; j++){
                        if(anotherCharge){
                            if(newList[i].aircrewId == oldList[j].aircrewId){
                                flag = true;
                                break;
                            }
                        } else {
                            if(same((Object.values(newList[i]))[0],(Object.values(oldList[j]))[0])){
                                flag = true;
                                break;
                            }
                        }
                    }

                    if(!flag){
                        res = true;
                        break;
                    }
                }
            }else{
                res = true;
            }
            return res;
        }

        function same(newObject, oldObject) {
            if (newObject != undefined && getId(newObject) == getId(oldObject)) {
                return true;
            }
            return false;
        }
    }

    function modalEditChargeCtrl (linkService, $uibModal, $uibModalInstance,assignAirCrewService, occupationCommandCrewCharges,
                                     occupationCrewCharges, indexX, assignForms,index, loadForm,messageService) {
        var vm = this;
        vm.assignAirCrewForm = {};
        vm.assignAirCrew = [];
        vm.indexX = indexX;
        vm.occupationCrewMembers = [];
        vm.assignForms = assignForms;
        vm.linkService = linkService;
        vm.$uibModal = $uibModal;

        vm.assignAirCrewForm = loadForm;
        vm.assignAirCrewForm.typeCrew = loadForm.typeCrew+"";

        vm.closeDialog = function () {
            $uibModalInstance.close();
        }

        vm.cancel = function () {
            $uibModalInstance.close();
        }

        vm.handleRadioChange = function (type) {
            if (type == 0) {
                vm.type = 0;
                vm.selectCrewRadioButton = false;
                vm.occupationCrews = [];
                vm.occupationCrews = occupationCommandCrewCharges;
            } else if (type == 1) {
                vm.type = 1;
                vm.selectCrewRadioButton = true;
                vm.occupationCrews = [];
                vm.occupationCrews = occupationCrewCharges;
            }
        };

        vm.handleRadioChange(vm.assignAirCrewForm.typeCrew);
        vm.fillMemberSelect = function (type, assignAirCrew) {
            vm.occupationCrewMembers = assignAirCrewService.getCrewByCrewType(type, assignAirCrew)
                .then(function (response) {
                    vm.occupationCrewMembers = response;
                });
        }

        vm.fillMemberSelect(vm.assignAirCrewForm.typeCrew, linkService.getLinkId(loadForm.occupationCrew._links.self.href))

        vm.deletePreviousItem = function (position){
            assignForms[indexX].assignAirCrew.splice(position, 1);
        }

        vm.saveAnotherCharge = function (isValid, assignAirCrew) {
            if (isValid) {
                if(!existMember(parseInt(linkService.getLinkId(assignAirCrew.member._links.self.href)),indexX)) {
                    assignForms[indexX].assignAirCrew[index] = {
                        "orden": 0,
                        "chargeName": assignAirCrew.occupationCrew.name,
                        "commandCrew": assignAirCrew.occupationCrew.commandCrew,
                        "member": assignAirCrew.member,
                        "charge": assignAirCrew.occupationCrew,
                        "aircrewId": parseInt(linkService.getLinkId(assignAirCrew.member._links.self.href)),
                        "occupationCrewId": parseInt(linkService.getLinkId(assignAirCrew.occupationCrew._links.self.href))
                    }
                }else{
                    messageService.registerError('');
                }
                $uibModalInstance.close()
            }
        };

        vm.addNewCrew = function (assignAirCrewForm, selectedItemsDialog) {
            var view = "";
            var controller = "";

            vm.assignAirCrewForm.typeCrew = parseInt(selectedItemsDialog);
            function verify() {
                vm.showMessage = true;
                $timeout(function () {
                    $timeout(function () {
                        vm.showMessage = false;
                    }, 2000);

                }, 2000);
            }

            if (isNaN(parseFloat(assignAirCrewForm.typeCrew))) {
                verify();
                return;
            } else {
                if (assignAirCrewForm.typeCrew == 0) {
                    view = "addNewCrew";
                    controller = "modalAddNewCommandCrewCtrl";
                }
                else if (assignAirCrewForm.typeCrew == 1) {
                    view = "addNewCommandCrew";
                    controller = "modalAddNewComplementaryCrewCtrl";
                }
            }

            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/flightControl/airCrew/assignAirCrew/' + view + '.html',
                controller: controller,
                controllerAs: 'vm',
                windowClass: 'zindex',
                backdrop: false,
                resolve: {
                    'occupationCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                        return assignAirCrewService.getOccupationCrewCharge()
                    }],
                    'indexX': [function () {
                        return indexX
                    }],
                    'modelAirCrafts': ['modelAircraftService', function (modelAircraftService) {
                        return modelAircraftService.getModelAircrafts()
                    }],
                    'isModal': 1,
                    'typeCrew': vm.assignAirCrewForm.typeCrew
                }
            });
            modalInstance.result.then(function (res) {
                vm.indexX = indexX;
                if(vm.assignAirCrewForm.occupationCrew){
                    vm.fillMemberSelect(vm.assignAirCrewForm.typeCrew, linkService.getLinkId(vm.assignAirCrewForm.occupationCrew._links.self.href))
                }
                vm.assignAirCrewForm.typeCrew = assignAirCrewForm.typeCrew;
            }, function () {
                vm.indexX = indexX;
            });
        }

        function existMember(id, index){
            var res = false;
            angular.forEach(vm.assignForms[index].assignAirCrew, function(assignAirCrew){
                if(assignAirCrew.aircrewId==id){
                    res=true;
                }
            })
            return res;
        }
    }

    function modalAddNewChargeCtrl(linkService,$uibModal,$uibModalInstance,assignAirCrewService,occupationCrewCharges,
                                   occupationCommandCrewCharges,indexX, assignForms,$timeout, messageService) {
        var vm = this;
        vm.assignAirCrewForm = {
            typeCrew: 1
        };
        vm.assignAirCrew = [];
        vm.indexX = indexX;
        vm.occupationCrewMembers = [];
        vm.assignForms = assignForms;
        vm.linkService = linkService;
        vm.$uibModal = $uibModal;
        vm.isDisabledCrew = true;
        vm.crewMemberSelect = null;
        vm.typeCargoCrew = null;

        vm.closeDialog = function () {
            $uibModalInstance.close();
        }

        vm.handleRadioChange = function (type) {
            if (type === 0) {
                vm.type = 0;
                vm.selectCrewRadioButton = false;
                vm.occupationCrews = [];
                vm.occupationCrews = occupationCommandCrewCharges;
            } else if (type === 1) {
                vm.type = 1;
                vm.selectCrewRadioButton = true;
                vm.occupationCrews = [];
                vm.occupationCrews = occupationCrewCharges;
            }
        };

        vm.handleRadioChange(vm.assignAirCrewForm.typeCrew);

        // vm.fillMemberSelect = function (type, assignAirCrew, airCrew) {
        vm.fillMemberSelect = function () {
            if(vm.assignAirCrewForm.occupationCrew !== undefined) {
                vm.occupationCrewMembers = assignAirCrewService.getCrewByCrewType(vm.assignAirCrewForm.typeCrew, vm.linkService.getLinkId(vm.assignAirCrewForm.occupationCrew._links.self.href))
                    .then(function (response) {
                        vm.occupationCrewMembers = response;
                        vm.isDisabledCrew = false;
                        vm.typeCargoCrew = (vm.assignAirCrewForm.occupationCrew.initials === 'PLT') ? 0 : 1;
                        if(vm.crewMemberSelect != null) {
                            vm.assignAirCrewForm.member = vm.crewMemberSelect;
                        }
                    });
            } else {
                vm.occupationCrewMembers =[];
                vm.isDisabledCrew = true;
                vm.typeCargoCrew = null;
            }
        }

        vm.saveAnotherCharge = function (isValid, assignAirCrew) {
            if (isValid) {
                if(!existMember(parseInt(linkService.getLinkId(assignAirCrew.member._links.self.href)),indexX)) {
                    vm.assignForms[vm.indexX].assignAirCrew.push({
                        "orden": 0,
                        "chargeName": assignAirCrew.occupationCrew.name,
                        "commandCrew": assignAirCrew.occupationCrew.commandCrew,
                        "member": assignAirCrew.member,
                        "charge": assignAirCrew.occupationCrew,
                        "aircrewId": parseInt(linkService.getLinkId(assignAirCrew.member._links.self.href)),
                        "occupationCrewId": parseInt(linkService.getLinkId(assignAirCrew.occupationCrew._links.self.href))
                    });
                }else{
                    messageService.registerError('');
                }
                vm.closeDialog();
            }
        };

        vm.addNewCrew = function (assignAirCrewForm, selectedItemsDialog) {
            var view = "";
            var controller = "";

            vm.assignAirCrewForm.typeCrew = parseInt(selectedItemsDialog);
            function verify() {
                vm.showMessage = true;
                $timeout(function () {
                    $timeout(function () {
                        vm.showMessage = false;
                    }, 2000);

                }, 2000);
            }

            if (isNaN(parseFloat(assignAirCrewForm.typeCrew))) {
                verify();
                return;
            } else {
                if (assignAirCrewForm.typeCrew == 0) {
                    view = "addNewCrew";
                    controller = "modalAddNewCommandCrewCtrl";
                }
                else if (assignAirCrewForm.typeCrew == 1) {
                    view = "addNewCommandCrew";
                    controller = "modalAddNewComplementaryCrewCtrl";
                }
            }

            var modalInstance = vm.$uibModal.open({
                templateUrl: 'app/admin/flightControl/airCrew/assignAirCrew/' + view + '.html',
                controller: controller,
                controllerAs: 'vm',
                windowClass: 'zindex',
                backdrop: false,
                resolve: {
                    'occupationCrewCharges': ['assignAirCrewService', function (assignAirCrewService) {
                        return assignAirCrewService.getOccupationCrewCharge()
                    }],
                    'indexX': [function () {
                        return indexX
                    }],
                    'modelAirCrafts': ['modelAircraftService', function (modelAircraftService) {
                        return modelAircraftService.getModelAircrafts()
                    }],
                    'isModal': 1,
                    'typeCrew': [function () {
                        return vm.typeCargoCrew
                    }]
                }
            });
            modalInstance.result.then(function (res) {
                vm.indexX = indexX;
                if(vm.assignAirCrewForm.occupationCrew){
                    //vm.fillMemberSelect(vm.assignAirCrewForm.typeCrew, linkService.getLinkId(vm.assignAirCrewForm.occupationCrew._links.self.href), res.airCrew)
                    vm.crewMemberSelect = res.airCrew;
                    vm.fillMemberSelect()
                }
                vm.assignAirCrewForm.typeCrew = assignAirCrewForm.typeCrew;
            }, function () {
                vm.indexX = indexX;
            });
        }

        function existMember(id, index){
            var res = false;
            angular.forEach(vm.assignForms[index].assignAirCrew, function(assignAirCrew){
                if(assignAirCrew.aircrewId==id){
                    res=true;
                }
            })
            return res;
        }
    }

    function modalAddNewCommandCrewCtrl(linkService, $uibModal, $uibModalInstance, occupationCrewService,isModal,
                                        typeCrew,occupationCrewCharges, modelAirCrafts,datePickerService, airCrewService) {
        var vm = this;
        vm.assignAirCrewForm = {};
        vm.assignAirCrew = [];
        vm.$uibModal = $uibModal;
        vm.occupationCrewService = occupationCrewService;
        vm.modelAircrafts = modelAirCrafts.data._embedded.modelAircrafts;
        vm.isModal = isModal;

        vm.crew = {
            typeCrew: typeCrew
        };

        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: false
            },
            closed: function (args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };
        // CALENDAR ================================================================

        vm.closeDialog = function (response) {
            $uibModalInstance.close(response);
        }

        vm.cancel = function () {
            $uibModalInstance.close({airCrew: null});
        }

        vm.saveAddNewCrew = function(isValid) {
            var save = {
                "name": vm.crew.name,
                "lastName": vm.crew.lastName,
                "nroIdentity": vm.crew.nroIdentity,
                "address": vm.crew.address,
                "phone": vm.crew.phone,
                "license": vm.crew.license,
                "expirationDate": moment(vm.crew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": 1,
                "modelAircraftId":  vm.crew.modeAirCraft.modelAircraftId,
                "makerId":  vm.crew.modeAirCraft.makerId,
                "typeCrew": vm.crew.typeCrew
            }

            if (isValid) {
                airCrewService.saveAddAirCrew(save)
                    .then(function (result) {
                        vm.closeDialog({airCrew: result.data});
                    });
            }
        }

        vm.saveAirCrew = function (isValid, airCrew) {
            var save = {
                "name": airCrew.name,
                "lastName": airCrew.lastName,
                "nroIdentity": airCrew.nroIdentity,
                "address": airCrew.address,
                "phone": airCrew.phone,
                "license": airCrew.license,
                "expirationDate": moment(airCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": 1,
                "modelAircraftId":  airCrew.modeAirCraft.modelAircraftId,
                "makerId":  airCrew.modeAirCraft.makerId,
                "typeCrew": airCrew.typeCrew
            }

            if (isValid) {
                airCrewService.saveAirCrew(save)
                    .then(function (result) {
                        vm.closeDialog();
                    });
            }
        }
    }

    function modalAddNewComplementaryCrewCtrl(linkService, $uibModal, $uibModalInstance, occupationCrewService,isModal,
                                              occupationCrewCharges,modelAirCrafts,datePickerService,complementAirCrewService) {
        var vm = this;
        vm.assignAirCrewForm = {};
        vm.assignAirCrew = [];
        vm.occupationComplementAirCrewList = occupationCrewCharges;
        vm.$uibModal = $uibModal;
        vm.isModal = isModal;
        vm.occupationCrewService = occupationCrewService;
        vm.modelAircrafts = modelAirCrafts.data._embedded.modelAircrafts;

        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: false
            },
            closed: function (args) {
                var valueDate = args.closeDate;
                vm.datepickerTo.datepickerOptions.minDate = valueDate;
            }
        };

        vm.datepickerTo = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        };
        // CALENDAR ================================================================

        vm.closeDialog = function () {
            $uibModalInstance.close();
        }

        vm.cancel = function () {
            $uibModalInstance.close();
        }

        vm.saveComplementAirCrew = function (isValid, complementAirCrew) {
            var save = {
                "name": complementAirCrew.name,
                "lastName": complementAirCrew.lastName,
                "nroIdentity": complementAirCrew.nroIdentity,
                "address": complementAirCrew.address,
                "phone": complementAirCrew.phone,
                "license": complementAirCrew.license,
                "expirationDate": moment(complementAirCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": parseInt(linkService.getLinkId(complementAirCrew.charge._links.self.href)),
                "modelAircraftId": complementAirCrew.modeAirCraft.modelAircraftId,
                "makerId": complementAirCrew.modeAirCraft.makerId,
                "typeCrew": 2
            }
            if (isValid) {
                complementAirCrewService.saveComplementAirCrew(save)
                    .then(function (result) {
                        vm.cancel();
                    });
            }
        }
    }
})();
